// Locale-aware money formatting. Amounts stay in their currency (default EUR);
// only the NUMBER/symbol formatting adapts to the active language/locale
// (e.g. fr → "1 234,56 €", en → "€1,234.56"). No FX conversion.

export function formatMoney(amount, lang = "fr", currency = "EUR", opts = {}) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return "";
  const locale = (lang || "fr").split("-")[0];
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: opts.decimals ?? 2,
      maximumFractionDigits: opts.decimals ?? 2,
    }).format(value);
  } catch {
    return `${value.toFixed(opts.decimals ?? 2)} ${currency}`;
  }
}

// Whole-number money (no decimals) — handy for round fees like "39 €".
export function formatMoneyInt(amount, lang = "fr", currency = "EUR") {
  return formatMoney(amount, lang, currency, { decimals: 0 });
}
